<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="PropertyId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="!is_listDialog && isShow"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.docList"
      urlHash="business/sales/saleby"
      @showRow="toggleRow"
      :showTrendTable="isShow"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="业务类型" label-width="85px">   
          <el-select  v-model="params.BusinessTypeId" clearable :disabled="isSelect">
            <el-option
              v-for="item in businessTypeList"
              :key="item.BusinessTypeId"
              :label="item.BusinessType"
              :value="item.BusinessTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-table
      class="subItem-table"
      :data="subList"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="left" label="存货编码" min-width="140px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductNo }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="ProductName"
        label="存货名称"
        min-width="140px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column align="left" label="规格型号">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="颜色" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销售单位">
        <template slot-scope="{ row }">
          <span>{{ row.SaUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.SaQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="计量单位2" min-width="120px">
        <template slot-scope="{ row }">
          <!-- <span>{{ row }}{{ $index }}</span> -->
          <span>{{ row.UnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量2">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="换算率">
        <template slot-scope="{ row }">
          <span>{{ row.Rate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税进价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.PurchasePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税售价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.SalePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最低售价" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.RetailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.QuotedPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="税率%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        label="单价"
        min-width="100px"
         v-if="canPrice"
      >
        <template slot-scope="{ row }">
          <span>{{ row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxLimit) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="预计交货日期" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column align="center" label="行中止">
        <template slot-scope="{ row }">
          <el-checkbox v-model="row.LineAbort" :disabled="true"></el-checkbox>
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" label="中止人">
        <template slot-scope="{ row }">
          <span>{{ row.LineAbortEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="中止时间" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" label="已采购数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.PurchaseQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已采购数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.PurchaseQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="累计生产数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductionQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="累计生产数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductionQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="执行数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ExecutionQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="执行数量2">
        <template slot-scope="{ row }">
          <span>{{ row.ExecutionQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源单据">
        <template slot-scope="{ row }">
          <span>{{ row.SourceTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源单号" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ row.DocNo }}</span>
        </template>
      </el-table-column>
    
      <el-table-column align="center" label="可用量">
        <template slot-scope="{ row }">
          <span>{{ row.LineAbortEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="现存量">
        <template slot-scope="{ row }">
          <span>{{ row.ExistQuantity }}</span>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/sales/sale/list.json";
import tableParam from "@/data/business/sales/sale/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  data() {
    return {
      api: require("@/api/sa/saDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      show: false,
      orderNo:"",
      TradeUnitId:0,
      FullName:'',
      WarehouseId: 0,
      WarehouseName: "",
      subList: [],
      subSelectList: [],
      params: {
        BusinessTypeId: null,
      },
      tempParams: {},
      businessTypeList: [],
      ordertype:""
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/sales/saleby");
    },
  },
  // props: {
  //   is_listDialog: {
  //     typeof: Boolean,
  //     default: false,
  //   },
  // },
  activated(){
    this.getRouterInfo()
  },
  mounted(){
    this.getBusinessType();
    if (!this.$permission.canPrice("/business/sales/saleby")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "Amount");
      list.tableList.splice(findIndex, 1);
    }

  },
  methods: {
    getBusinessType(){
      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "销货单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
      
              }
            });
        }
      });
    },
    getRouterInfo(){
      if(this.$router.history.current.params){
        this.tempParams.SourceDocNo= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocNo
        };
        this.tempParams.OrderType= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderType
        };
        this.tempParams.Ids= {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.Ids
        };
        this.$refs.list.getData()
      }    
    },
    // 选择报价明细
    handleSelectionChange(data) {
      data.forEach(e => {
        e.WarehouseId = e.WarehouseId||this.WarehouseId;
        e.WarehouseName = e.WarehouseName||this.WarehouseName;
      })
      this.subSelectList = data;
      console.log("?!!!@",data);
    },
    toggleRow(data) {
      // console.log('object',data);
      // if (!this.is_listDialog) return;
      console.log(data,'data')
      this.orderNo = data.DocNo
      
      this.TradeUnitId=data.TradeUnitId;
      this.FullName=data.FullName;
      this.WarehouseId = data.WarehouseId;
      this.WarehouseName = data.WarehouseName;

      if(this.isSelect){
        data.Products.forEach(item => {
          if(this.ordertype=="销售出库单"){
            item.SaQuantity = item.SaQuantity - (item.StOutDocOccupyQuantity ?? 0)
          }else{
            item.SaQuantity = item.SaQuantity - (item.SaDocInvoiceOccupyQuantity ?? 0)
          }
          
          item.Amount = item.SaQuantity * item.Price;
          item.TaxAmount = item.SaQuantity * item.TaxPrice;
        })

        let tList = data.Products.filter(x=>x.SaQuantity!=0);
        console.log('tList', tList)
        this.subList = tList;
      }else{
        this.subList = data.Products;
      }

      // if (this.subList.length > 0) this.show = true;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
